import React from "react";
import Header from "./include/Header";
import { Outlet } from "react-router-dom";
import Footer from "./include/Footer";

function Layout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />

      <main className="flex-grow-1 outlet">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}

export default Layout;
